import AuthLayout from "./AuthLayout";
import AuthBanner from "./AuthBanner";

// Enter anywhere in the form submits it, without relying on the browser's
// implicit submission (which a stray type="button" would silently break).
const submitOnEnter = (e) => {
  if (e.key === "Enter" && e.target.tagName === "INPUT") {
    e.preventDefault();
    e.currentTarget.requestSubmit();
  }
};

// Shell shared by every unauthenticated form (login, request reset, reset password).
// Keeps the heading, spacing and the error/success banners identical across portals.
const AuthFormLayout = ({
  title,
  subtitle,
  error,
  success,
  onSubmit,
  children,
  footer,
  topLink,
  width,
}) => (
  <AuthLayout topLink={topLink} width={width}>
    <form onSubmit={onSubmit} onKeyDown={submitOnEnter} noValidate>
      <h1 className="text-center text-[28px] font-medium leading-tight text-gray-900">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-2 text-center text-sm text-gray-500">{subtitle}</p>
      )}

      <AuthBanner error={error} success={success} />

      <div className="mt-8 space-y-5">{children}</div>

      {footer && <div className="mt-6">{footer}</div>}
    </form>
  </AuthLayout>
);

export default AuthFormLayout;
